import React from 'react';
import { Button, Table, } from 'react-bootstrap';

export default class CheckSetComponent extends React.Component {

    render() {
        let countMap = this.props.countMap;

        let getCount = (countMap, key) => {
            if (countMap.get(key)) {
                return key + ' ( ' + countMap.get(key) + ' )';
            } else {
                return key;
            }
        }

        let disabledState = (value) => {
            return value;
        }

        return (
            <Table striped bordered condensed hover>
                <thead>
                    <tr>
                        <th colSpan='2' >{getCount(countMap, this.props.ckset.description)}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.ckset.checkItems.map(
                        (ckItem, ckIndex) => {
                            if (!ckItem.show) {
                                return;
                            }

                            return <tr key={ckIndex}>
                                <td width="90%">{ckItem.description}</td>
                                <td width="10%">
                                    <Button
                                        bsStyle="primary"
                                        disabled={disabledState(this.props.disabled)}
                                        onClick={(event) => {
                                            this.props.addCkDetail(
                                                this.props.card,
                                                this.props.category.id,
                                                this.props.ckset.id,
                                                ckItem.id);
                                        }}>+</Button>
                                </td>
                            </tr>
                        }
                    )}
                </tbody>
            </Table>
        )
    }
};



// WEBPACK FOOTER //
// ./src/components/CheckSetComponent.jsx